module.exports = __webpack_public_path__ + "static/media/choromeDev.5aed3098.png";